import type { FC } from 'react'
import { useState } from 'react'

import RemoveButton from '@/components/RemoveButton'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
}

const RemoveLandlordReference: FC<Props> = ({ customerId, subjectId }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          subjectId={subjectId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <RemoveButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default RemoveLandlordReference
